// Hook para acceder a la configuración
export const useConfig = () => {
  // Acceder a la configuración global
  const config = window.ECLIPSE_CONFIG || {
    links: {
      spotifyArtist: 'https://open.spotify.com/artist/XXXX',
      spotifyAlbum: 'https://open.spotify.com/album/XXXX',
      youtube: 'https://youtube.com/@eclipseheaven',
      appleMusic: 'https://music.apple.com/artist/XXXX',
      instagram: 'https://www.instagram.com/eclipse_heaven_band',
      tiktok: 'https://www.tiktok.com/@eclipseheaven',
      bookingEmail: 'booking@moonlightreworks.com',
      labelWebsite: 'https://www.moonlightreworks.com',
      pressKitDownload: '#',
    },
    images: {
      heroBackground: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?q=80&w=2574',
      aboutImage: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?q=80&w=1583',
      albumCover: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=80&w=2070',
      seal1: 'https://images.unsplash.com/photo-1518331647614-7a1f04cd34cf?q=80&w=2070',
      seal2: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?q=80&w=2070',
      seal3: 'https://images.unsplash.com/photo-1550859492-d5da9d8e45f3?q=80&w=2070',
      seal4: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2070',
      gallery: [
        'https://images.unsplash.com/photo-1511735111819-9a3f7709049c?q=80&w=2069',
        'https://images.unsplash.com/photo-1501612780327-45045538702b?q=80&w=2070',
        'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=80&w=2070',
        'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?q=80&w=1583',
        'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2070',
        'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?q=80&w=2574',
        'https://images.unsplash.com/photo-1518331647614-7a1f04cd34cf?q=80&w=2070',
        'https://images.unsplash.com/photo-1511379938547-c1f69419868d?q=80&w=2070',
        'https://images.unsplash.com/photo-1550859492-d5da9d8e45f3?q=80&w=2070',
      ],
      ogImage: '/og-cover.jpg',
    },
    band: {
      name: 'Eclipse Heaven',
      tagline: 'Cinematic rock. Sacred resonance.',
      albumName: 'Divine Fire',
      albumYear: '2025',
      label: 'Moonlight Reworks',
    },
    embeds: {
      spotifyEmbed: '',
      youtubeEmbed: '',
    },
  };

  return config;
};
